var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}
import React from 'react';
import { Navigate } from 'react-router';
import LibraryRoot from "./Library/Library";
import { LibraryCards } from "./Library/LibraryCards";
import { LibraryMap } from "./Library/LibraryMap";
import { LibraryTable } from "./Library/LibraryTable";
import { PageView } from "./Pages/PageView";
import { Login } from "./Users/Login";
import { validateHomePageRoute } from "./utils/routeHelpers";
import { ViewerRoute } from "./Viewer/ViewerRoute";

const deconstructSearchQuery = (query) => {
  if (!query) return '';
  if (query.startsWith('?q=')) {
    return decodeURI(query.substring(1).split('=')[1]);
  }
  return `(${query.substring(1)})`;
};

const getCustomLibraryPage = (customHomePage) => {
  const [query] = customHomePage.filter((path) => path.startsWith('?'));
  const searchQuery = deconstructSearchQuery(query);
  const queryString = query ? searchQuery : '';
  if (customHomePage.includes('map')) {
    return (/*#__PURE__*/
      _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
      _jsx(LibraryMap, { params: { q: queryString } })
      ));

  }

  if (customHomePage.includes('table')) {
    return (/*#__PURE__*/
      _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
      _jsx(LibraryTable, { params: { q: queryString } })
      ));

  }

  return (/*#__PURE__*/
    _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
    _jsx(LibraryCards, { params: { q: queryString } })
    ));

};

const getLibraryDefault = (
userId,
defaultLibraryView,
privateInstance) =>
{
  if (privateInstance && !userId) {
    return /*#__PURE__*/_jsx(Login, {});
  }

  switch (defaultLibraryView) {
    case 'table':
      return (/*#__PURE__*/
        _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
        _jsx(LibraryTable, { params: { q: '(includeUnpublished:!t)' } })
        ));


    case 'map':
      return (/*#__PURE__*/
        _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
        _jsx(LibraryMap, { params: { q: '(includeUnpublished:!t)' } })
        ));


    case 'cards':
    default:
      return (/*#__PURE__*/
        _jsx(LibraryRoot, {}, void 0, /*#__PURE__*/
        _jsx(LibraryCards, { params: { q: '(includeUnpublished:!t)' } })
        ));

  }
};

// eslint-disable-next-line max-statements
const getIndexElement = (settings, userId) => {
  const customHomePage = settings !== null && settings !== void 0 && settings.home_page ? settings === null || settings === void 0 ? void 0 : settings.home_page.split('/').filter((v) => v) : [];
  const isValidHomePage = validateHomePageRoute((settings === null || settings === void 0 ? void 0 : settings.home_page) || '');
  let element = /*#__PURE__*/_jsx(Navigate, { to: customHomePage.join('/') });
  let parameters;
  let defaultToLibrary = true;
  switch (true) {
    case !isValidHomePage || customHomePage.length === 0:
      element = getLibraryDefault(userId, settings === null || settings === void 0 ? void 0 : settings.defaultLibraryView, settings === null || settings === void 0 ? void 0 : settings.private);
      break;

    case isValidHomePage && customHomePage.includes('page'):
      {
        const pageId = customHomePage[customHomePage.indexOf('page') + 1];
        element = /*#__PURE__*/_jsx(PageView, { params: { sharedId: pageId } });
        parameters = { sharedId: pageId };
        defaultToLibrary = false;
      }
      break;

    case isValidHomePage && customHomePage.includes('entity'):
      {
        const pageId = customHomePage[customHomePage.indexOf('entity') + 1];
        element = /*#__PURE__*/_jsx(ViewerRoute, { params: { sharedId: pageId } });
        defaultToLibrary = false;
      }
      break;

    case isValidHomePage && customHomePage.includes('library'):
      element = getCustomLibraryPage(customHomePage);
      break;

    default:
      break;
  }

  return { element, parameters, defaultToLibrary };
};

export { getIndexElement };